import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class A18SharedDataService {
  private _plannerSelectedRegion?: number;

  setPlannerSelectedRegion(value: number) {
    this._plannerSelectedRegion = value;
  }

  getPlannerSelectedRegion(): number | undefined {
    return this._plannerSelectedRegion;
  }
}
